import _ from "lodash";
import formulars from "./fomulars";


const routes = [
  { path: '/', name: 'index', component: () => import("../../views/Index") },
  { path: '/scan', name: 'scan', component: () => import("../../views/Scan") },
  { path: '/formular/:token', name: 'formular', component: () => import("../../views/formulars/Index.vue"), props: true },
  { path: '*', name: 'all', component: () => import("../../views/Scan.vue") },
]

export default _.flatten([
  routes,
  formulars
])
